export default class CookieDomainNameResolutionService {
  static getCookieDomainNameFromHostName(hostName) {
    const hostNameParts = hostName.split('.');
    return hostNameParts.length > 1
      ? hostNameParts.slice(1).join('.')
      : undefined;
  }
}
